module.exports = __webpack_public_path__ + "plugins/web/img/contact_me_qr.a44b3aed.png";